import {useCallback} from 'react'

import useCvip from './useCvip'
import {useWallet} from 'use-wallet'

import {enter, getXCvipStakingContract} from '../cvip/utils'

const useEnter = () => {
  const {account} = useWallet()
  const cvip = useCvip()

  const handle = useCallback(
    async (amount: string) => {
      const txHash = await enter(
        getXCvipStakingContract(cvip),
        amount,
        account,
      )
      console.log(txHash)
    },
    [account, cvip],
  )

  return {onEnter: handle}
}

export default useEnter
